"use strict";

const SettingsCtrl = function (CRUDService, config, Notification) {
    var ctrl = this;

    ctrl.$onInit = function() {
      CRUDService.getAll(config.urls.settings).then(function (data) {
        ctrl.settings = data;
      });
    };

    ctrl.save = function(form){
      if (form.$valid) {
        CRUDService.save(ctrl.settings).then(
          function(){
            Notification.success('Die Einstellungen wurden erfolgreich gespeichert.');
          },
          function(){
            Notification.error('Beim Speichern der Einstellungen ist ein Fehler aufgetreten.');
          }
        );
      }
    };

    ctrl.addSubject = function(){
      if (ctrl.newSubject) {
        ctrl.settings.mailSubjects.push(ctrl.newSubject);
        ctrl.newSubject = "";
      }
    };
  };

SettingsCtrl.$inject = ['CRUDService', 'config', 'Notification'];

module.exports = {
  template: require('./settings.component.html'),
  controller: SettingsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/settings/settings.component.js